module.exports = __webpack_public_path__ + "static/media/patreon.10ff2e4f.svg";